export default __webpack_public_path__ + "static/media/profilePic.f94ddf09.PNG";